import React, {createContext, useContext, useEffect, useMemo, useState} from "react";
import './scss/Content.scss';
import {Route, Switch, Redirect, useParams} from "react-router-dom"
import Surveys from "./views/Surveys"
import Contacts from "./views/Contacts"
import UsersView from "./views/Users"
import Sidebar from "./Sidebar"
import SurveyView from "./views/SurveyView"
import useWindowDimensions from "./DataFunctions";
import {PopupElement, PopupProvider, Snackbar} from "./UIElements";
import SupportBots from "./views/SupportBots";
import {SupportBotEditor} from "./views/SupportBotEditor/SupportBotEditor";
import {SupportBotProvider} from "./views/SupportBotEditor/SupportBotData";

export default function Content() {
    const [windowSizeClass, setWindowSizeClass] = useState("")
    let contentClass = "content-container " + windowSizeClass
    const {width} = useWindowDimensions()
    useEffect(()=>{
        if (windowSizeClass !== "tablet" && width < 769) {
            setWindowSizeClass("tablet")
        }
        if (windowSizeClass === "tablet" && width > 768) {
            setWindowSizeClass("")
        }
    },[width])

    const SurveyIdRedirect = () => {
        const { surveyId } = useParams()
        return <Redirect to={`/support-campaign/${surveyId}`} />
    }

    return <SnackbarWrapper>
        <div className={contentClass}>
            <Switch>
                <Route exact path={"/"}>
                    <Redirect to={"/support-campaigns"} />
                </Route>
                <Route path={"/support-campaigns"}>
                    <Sidebar />
                    <Surveys />
                </Route>
                <Route path={"/support-bots"}>
                    <Sidebar />
                    <SupportBotProvider>
                        <SupportBots />
                    </SupportBotProvider>
                </Route>
                <Route path={"/support-bot/:botId"}>
                    <Sidebar />
                    <SupportBotProvider>
                        <PopupProvider>
                            <SupportBotEditor />
                            <PopupElement />
                        </PopupProvider>
                    </SupportBotProvider>
                </Route>
                <Route path={"/contacts"}>
                    <Sidebar />
                    <Contacts />
                </Route>
                <Route path={"/users"}>
                    <Sidebar />
                    <UsersView />
                </Route>
                <Route path={'/support-campaign/:surveyId'}>
                    <Sidebar collapsed={true} />
                    <SurveyView />
                </Route>
                <Route path={"/campaign"}>
                    <Redirect to={"/support-campaigns"} />
                </Route>
                <Route path={"/campaigns"}>
                    <Redirect to={"/support-campaigns"} />
                </Route>
                <Route path={"/support-campaign"}>
                    <Redirect to={"/support-campaigns"} />
                </Route>
                <Route path={"/surveys"}>
                    <Redirect to={"/support-campaigns"} />
                </Route>
                <Route path={"/survey/:surveyId"}>
                    <SurveyIdRedirect />
                </Route>
            </Switch>
        </div>
    </SnackbarWrapper>
}

const SnackbarContext = createContext({
    show: false,
    text: "",
    state: "", //error, warning, info, success
    autoHide: true
})

function SnackbarWrapper({children}) {
    const [snackbarData, setSnackbarData] = useState(useContext(SnackbarContext))
    const value = useMemo(() => (
        {snackbarData, setSnackbarData}
    ), [snackbarData])

    return <SnackbarContext.Provider value={value}>
        {children}
        <Snackbar show={snackbarData.show} text={snackbarData.text} state={snackbarData.state} autoHide={snackbarData.autoHide} />
    </SnackbarContext.Provider>
}

export function useSnackbar() {
    const context = useContext(SnackbarContext)
    if (context === undefined) {
        throw new Error('useSnackbar must be used inside SnackbarWrapper')
    }
    return context
}